import { Routes } from '~/api/api-routes'
import axios from '~/api/axiosBase'

export const fetchShippingStructure = async () => {
  return (await axios.get(Routes.shipping.fetchStructure)).data
}
